import { Directive } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';

import { MessageService, AppBarTitleService, GooglePlacesFormHelper, GooglePlacesDetails } from 'common';

@UntilDestroy()
@Directive()
export abstract class ContactDataFormComponent {

  form: UntypedFormGroup;

  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
    protected messageService: MessageService,
    public snackBar: MatSnackBar,
    protected appBarTitleService: AppBarTitleService
  ) { }

  protected phoneValidator = Validators.compose([Validators.pattern(/^\(?(\d{3})\)?([ .-]?)(\d{3})\2(\d{4})$/)]);

  protected getAddressFormGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      line1: ['', Validators.compose([Validators.required,
      Validators.pattern(/^[a-zA-Z0-9]|[a-zA-Z0-9]\s$/), Validators.maxLength(255)])],
      line2: ['', Validators.compose([Validators.pattern(/^[a-zA-Z0-9]|[a-zA-Z0-9]\s$/), Validators.maxLength(255)])],
      city: ['', Validators.compose([Validators.required,
      Validators.pattern(/^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/), Validators.maxLength(40)])],
      state: ['', Validators.required],
      zip: ['', Validators.compose([Validators.required, Validators.pattern(/^\d{5}(-?\d{4})?$/)])]
    });
  }

  handleAddressChange(placeDetails: GooglePlacesDetails): void {
    const mappedData = GooglePlacesFormHelper.mapToFullAddress(placeDetails);
    this.form.patchValue({ address: mappedData}, { emitEvent: false });
    
    const addressSubForm = this.form.get('address') as UntypedFormGroup;
    addressSubForm?.markAllAsTouched();
  }

  handleCityAddressChange(placeDetails: GooglePlacesDetails): void {
    const mappedData = GooglePlacesFormHelper.mapToCityAddress(placeDetails);
    this.form.patchValue({ address: mappedData}, { emitEvent: false });
    
    const addressSubForm = this.form.get('address') as UntypedFormGroup;
    addressSubForm?.markAllAsTouched();
  }

  submitSubClear = () => {
    this.submitSub.unsubscribe();
    this.submitSub = null;
  };

  submitSub: Subscription;

  submitError = response => {
    this.submitSubClear();
    this.messageService.error("Error occurred while trying to update the data.");
  };

  submitSuccess = () => {
    this.submitSubClear();
    let router = this.router;
    this.snackBar.open("Your data has been updated", "OK", { duration: 2000 })
      .afterDismissed().subscribe(() => { router.navigate(["dashboard"]); });
  };

  states: string[] = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
  ];
}
